export default "__VITE_ASSET__So8oQd7i__"